import React, { useState } from "react";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    Typography,
    Button,
} from "@mui/material";
import { HelpOutline as HelpOutlineIcon } from "@mui/icons-material";

const AdminPageGuide = ({ title, steps = [], variant = "header" }) => {
    const [open, setOpen] = useState(false);

    const buttonSx =
        variant === "header"
            ? {
                  color: "white",
                  bgcolor: "rgba(255,255,255,0.2)",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.35)" },
              }
            : {
                  color: "primary.main",
                  bgcolor: "rgba(25, 118, 210, 0.08)",
                  "&:hover": { bgcolor: "rgba(25, 118, 210, 0.16)" },
              };

    return (
        <>
            <Tooltip title="Page guide">
                <IconButton
                    size="small"
                    onClick={() => setOpen(true)}
                    sx={buttonSx}
                    aria-label="Open page guide"
                >
                    <HelpOutlineIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
                aria-labelledby="admin-page-guide-title"
            >
                <DialogTitle id="admin-page-guide-title" sx={{ pb: 1 }}>
                    {title}
                </DialogTitle>
                <DialogContent dividers>
                    <Box component="ol" sx={{ m: 0, pl: 2.5 }}>
                        {steps.map((step, index) => (
                            <Typography
                                key={index}
                                component="li"
                                variant="body2"
                                sx={{ mb: index < steps.length - 1 ? 1.5 : 0, lineHeight: 1.6 }}
                            >
                                {step}
                            </Typography>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button onClick={() => setOpen(false)} variant="contained" size="small">
                        Got it
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AdminPageGuide;
